'use client';

import { useRouter } from "next/navigation";
import React, { Suspense, useState } from 'react';
import { encodePassphrase, generateRoomId, randomString } from '@/lib/client-utils';
import styles from '../styles/Home.module.css';
import { signInWithGoogle, anonymousLogin } from './config/auth/authService';
import { socialSignIn } from './services';

function LoginComponent() {
  const router = useRouter();
  const handleGoogleLogin = async () => {
    try {
      const user = await signInWithGoogle();
      console.log("User logged in with Google:", user);
      if (user) {
        const firebaseToken = await user.getIdToken();
        if (firebaseToken) {
          console.log('firebaseToken - ', firebaseToken);
          const response = await socialSignIn(firebaseToken);
          if (response) {
            console.log('TEST');
            localStorage.setItem('aaqInstance', JSON.stringify(response));
            router.push('/home');
          }
          console.log('RESPONSE FROM SOCIAL API - ', response);
        }
      }
      // Redirect or additional actions on successful Google login
    } catch (error: any) {
      console.error("Google login error:", error.message);
    }
  };

  const handleAnonymousLogin = async () => {
    try {
      const user = await anonymousLogin();
      console.log("User logged in Anonymously:", user);
      if (user) {
        const firebaseToken = await user.getIdToken();
        if (firebaseToken) {
          console.log('firebaseToken - ', firebaseToken);
          const response = await socialSignIn(firebaseToken);
          if (response) {
            console.log('TEST');
            localStorage.setItem('aaqInstance', JSON.stringify(response));
            router.push('/home');
          }
          console.log('RESPONSE FROM SOCIAL API - ', response);
        }
      }
      // Redirect or additional actions on successful Google login
    } catch (error: any) {
      console.error("Anonymous login error:", error.message);
    }
  }
  return (
    <div className={styles.signinContent}>
      <p style={{ margin: 0 }}>Sign in with</p>
      <button style={{ marginTop: '1rem', width: '100%' }} className="lk-button" onClick={handleGoogleLogin}>
        Google
      </button>
      {/* <button style={{ marginTop: '1rem', width: '100%' }} className="lk-button">
        Apple
      </button> */}
      {/* <p style={{ margin: 0 }}>or<button onClick={handleAnonymousLogin} type="button" style={{ marginTop: '1rem', backgroundColor: 'transparent', paddingLeft: '10px', fontWeight: 'bold' }} className='lk-button'>Skip now</button></p> */}
    </div>
  );
}


export default function Page() {
  return (
    <>
      <main className={styles.main} data-lk-theme="default">
        <div className="header login">
          <h1>AAQ
            <span>anytime, anywhere, quick connect</span>
          </h1>
          <h2>
            Hey, let's get started
            {/* on{' '}
            <a href="https://github.com/livekit/components-js?ref=meet" rel="noopener">
              LiveKit&nbsp;Components
            </a>
            ,{' '}
            <a href="https://livekit.io/cloud?ref=meet" rel="noopener">
              LiveKit&nbsp;Cloud
            </a>{' '}
            and Next.js. */}
          </h2>
        </div>
        <Suspense fallback="Loading">
          <LoginComponent />
        </Suspense>
      </main>
      <footer data-lk-theme="default">
        © 2024 AAQ. All rights reserved.
      </footer>
      {/* <footer data-lk-theme="default">
        Hosted on{' '}
        <a href="https://livekit.io/cloud?ref=meet" rel="noopener">
          LiveKit Cloud
        </a>
        . Source code on{' '}
        <a href="https://github.com/livekit/meet?ref=meet" rel="noopener">
          GitHub
        </a>
        .
      </footer> */}
    </>
  );
}
